export * from './lib/font.service.module';

export { AccredibleFontService } from './lib/font.service';
